/* limited-stock-badge.js — browser-time version with dynamic copy */
(() => {
  /* ---------- CONFIG ---------- */
  const OPEN_HOUR      = 7;   // 07:00
  const PRE_CLOSE_HOUR = 17;  // 17:00 (= 5 PM) — hits the floor
  const CLOSE_HOUR     = 19;  // 19:00 (= 7 PM)
  const START_MIN      = 10;  // opening fake-stock window
  const START_MAX      = 15;
  const FLOOR_MIN      = 2;   // floor reached at 5 PM
  const FLOOR_MAX      = 5;
  const PRE_ORDER      = 'Pre order';

  /* ---------- HELPERS ---------- */
  const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  const todayStamp = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const key  = (kind, pid, date) => `ls-${kind}-${pid}-${date}`;
  const load = (k, fb) => { const v = localStorage.getItem(k); return v ? parseInt(v,10) : fb; };
  const save = (k, v) => localStorage.setItem(k, v);

  /* ---------- MAIN ---------- */
  document.querySelectorAll('.limited-stock-badge').forEach((el) => {
    const pid    = el.dataset.productId;
    const invCap = +el.dataset.maxInv;
    if (invCap === 0) { el.remove(); return; } // sold-out guardrail

    const now        = new Date();
    const hour       = now.getHours();
    const minute     = now.getMinutes();
    const day        = now.getDay();           // 0 = Sun … 6 = Sat
    const isOpenDay  = day >= 0 && day <= 6;   // Sun–Sat
    const isOpenHour = hour >= OPEN_HOUR && hour < CLOSE_HOUR;
    const active     = isOpenDay && isOpenHour; // <-- WE DEFINE IT HERE

    let qty;

    if (active) {
      /* ---------- ACTIVE HOURS ---------- */
      const dateKey = todayStamp(now);
      const baseKey  = key('base',  pid, dateKey);
      const floorKey = key('floor', pid, dateKey);

      const base  = load(baseKey,  Math.min(rand(START_MIN,  START_MAX), invCap));
      const floor = load(floorKey, Math.min(rand(FLOOR_MIN,  FLOOR_MAX), base));

      save(baseKey, base);  save(floorKey, floor);

      const hrsSinceOpen = (hour + minute/60) - OPEN_HOUR; // 0–12
      const progress = Math.min(Math.max(hrsSinceOpen / (PRE_CLOSE_HOUR - OPEN_HOUR), 0), 1);
      
      qty = Math.round(base - (base - floor) * progress);
    } else {
      /* ---------- CLOSED HOURS ---------- */
      const nightDate = hour >= CLOSE_HOUR ? todayStamp(now) : (() => {
        const y = new Date(now); y.setDate(now.getDate()-1); return todayStamp(y);
      })();
      const nightKey = key('night', pid, nightDate);
      qty = load(nightKey, Math.min(rand(START_MIN, START_MAX), invCap));
      save(nightKey, qty);
    }

    /* ---------- RENDER & MESSAGING ---------- */
    qty = Math.max(1, Math.min(qty, invCap));   // safety clamp

    const msg = active
      ? `Fresh batch – only ${qty} left for TODAY!`
      : `Baked fresh next day · ${qty} available`;

    const target = el.querySelector('.limited-stock-badge__txt');
    target.textContent = msg;
    el.style.display = 'inline-block';

    const button = document.querySelector('.product-form__buttons button');
    const label = button.querySelector('span');

    if(label.textContent.trim() === PRE_ORDER) {
      target.textContent = 'Sold out';
    }

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          if(label.textContent.trim() === PRE_ORDER) {
            target.textContent = 'Sold out';
          } else {
            target.textContent = msg;
          }
        }
      }
    });

    observer.observe(label, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });
})();
